export const tr = {
    error: 'Hata oluştu, daha sonra tekrar deneyin',
    'remove-confirm': 'Bu ürünü ({product}) silmek istediğinizden emin misiniz?',
    'remove-success': 'Ürün silindi'
};
